(function () {
  function initGridCounters() {
    var elements = document.querySelectorAll('[data-stat-animate]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    elements.forEach(function (el) {
      if (el.dataset.statCounted) return;
      observer.observe(el);
    });
  }

  function animateCounter(el) {
    var targetValue = el.dataset.statNumber;
    var numberEl = el.querySelector('.grid-stat__number');
    if (!numberEl || el.dataset.statCounted) return;

    el.dataset.statCounted = 'true';

    var target = parseFloat(targetValue);
    if (isNaN(target)) return;

    var hasDecimal = targetValue.indexOf('.') !== -1;
    var decimalPlaces = hasDecimal ? targetValue.split('.')[1].length : 0;
    var duration = 1600;
    var startTime = null;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var easedProgress = easeOutCubic(progress);
      var current = easedProgress * target;

      numberEl.textContent = current.toFixed(decimalPlaces);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        numberEl.textContent = targetValue;
      }
    }

    numberEl.textContent = (0).toFixed(decimalPlaces);
    requestAnimationFrame(step);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGridCounters);
  } else {
    initGridCounters();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initGridCounters);
  }
})();